var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRepliesTrigger = function SvgRepliesTrigger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.30556L5.41667 2.30556M5.41667 2.30556C5.41667 3.16467 6.11311 3.86111 6.97222 3.86111C7.83133 3.86111 8.52778 3.16467 8.52778 2.30556C8.52778 1.44645 7.83133 0.75 6.97222 0.75C6.11311 0.75 5.41667 1.44645 5.41667 2.30556ZM11.6389 2.30556L14.75 2.30556M0.749999 7.75L5.41667 7.75M11.6389 7.75L14.75 7.75M11.6389 7.75C11.6389 6.89089 10.9424 6.19444 10.0833 6.19444C9.22422 6.19444 8.52778 6.89089 8.52778 7.75C8.52778 8.60911 9.22422 9.30556 10.0833 9.30556C10.9424 9.30556 11.6389 8.60911 11.6389 7.75ZM0.749999 13.1944L3.86111 13.1944M3.86111 13.1944C3.86111 14.0536 4.55756 14.75 5.41667 14.75C6.27578 14.75 6.97222 14.0536 6.97222 13.1944C6.97222 12.3353 6.27578 11.6389 5.41667 11.6389C4.55756 11.6389 3.86111 12.3353 3.86111 13.1944ZM10.0833 13.1944L14.75 13.1944",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRepliesTrigger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replies-trigger.f8b29e8b.svg";
export { ForwardRef as ReactComponent };